import { Validator } from 'pi-validation';

export type APValidator = Validator;

angular.module('capability-ng-academic-planner').service('ngAPValidator', () => {
  return new Validator();
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/validators/ap_validator.ts